import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useCart } from '@/context/CartContext';

export const CartButton = () => {
  const { itemCount, total, openCart, isEmpty } = useCart();

  return (
    <Button
      onClick={openCart}
      variant="outline"
      className={`relative border-2 ${
        isEmpty 
          ? 'border-muted-foreground/20 text-muted-foreground' 
          : 'border-instagram-purple/50 text-foreground hover:border-instagram-purple'
      } transition-all`}
    >
      <ShoppingCart className={`w-4 h-4 mr-2 ${!isEmpty && 'text-instagram-purple'}`} />
      <span className="hidden sm:inline">
        {isEmpty ? 'Carrello' : `€${total.toFixed(2)}`}
      </span>
      {itemCount > 0 && (
        <Badge 
          className="absolute -top-2 -right-2 h-5 w-5 p-0 flex items-center justify-center gradient-instagram text-primary-foreground text-xs"
        >
          {itemCount}
        </Badge>
      )}
    </Button>
  );
};
